import { getLoggedInUserSubscription} from "../store/iam/selectors";
import { trackedWebsites } from "../store/tracked_websites/selectors";
import { navigate } from "../store/navigation/operations";

const allowedRoutes = [
  "/subscription/plans",
  "/user/account/profile",
  "/user/account/billing",
  "/auth/logout",
  "/auth/login",
  "/free-trial-setup"
];

const accessControlMiddleware = store => next => action => {  
  if (action.type === "@@router/LOCATION_CHANGE") {
    const pathname = action.payload.location.pathname;    

    // if(pathname === '/auth/login' && isLoggedIn(store.getState())){
    //   action.payload.location.pathname = "/dashboard";
    //   store.dispatch(navigate("dashboard"));
    //   return next(action);
    // }

    const subscription = getLoggedInUserSubscription(store.getState());

    if (
      typeof subscription === "object" &&
      subscription !== null &&
      Object.keys(subscription).length === 0 &&
      trackedWebsites(store.getState()).length === 0
    ) {
      if (pathname !== "/free-trial-setup") {
        action.payload.location.pathname = "/free-trial-setup";
        store.dispatch(navigate("free-trial-setup"));
        return next(action);
      }
    }

    if (!allowedRoutes.includes(pathname) && !pathname.startsWith("/subscription/checkout/")) {
      if (subscription && subscription["status"] === "expired") {
        action.payload.location.pathname = "/subscription/plans";
        store.dispatch(navigate("subscription/plans"));
      }
    }
  }

  return next(action);
};

export default accessControlMiddleware;
